import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Collapse } from 'antd'

const { Panel } = Collapse

const DEFAULT_ACTIVE_KEY = 1
const DEFAULT_DISABLED_KEY = 0

interface CustomCollapseProps {
  title?: string
  items: any[]
  titleClassName?: string
  itemsToShow: number
  contentOnly?: boolean
  content: any
  seeMoreTitle?: string
  seeLessTitle?: string
}

const CustomCollapse: React.FC<CustomCollapseProps> = ({
  title,
  items,
  titleClassName,
  itemsToShow,
  content,
  contentOnly,
  seeMoreTitle,
  seeLessTitle,
}) => {
  const [activeKey, setActiveKey] = useState(DEFAULT_DISABLED_KEY)
  const [viewMoreDetails, setViewMoreDetails] = useState(false)
  const { t: translate } = useTranslation()

  if (itemsToShow > items.length) itemsToShow = items.length

  const seeLessActions = (
    <section>
      <span
        onClick={(e) => {
          setViewMoreDetails(false)
          setActiveKey(DEFAULT_DISABLED_KEY)
          e.stopPropagation()
        }}
        className="link right"
      >
        {seeLessTitle ? seeLessTitle : translate('general.see-less')}
      </span>
    </section>
  )

  const seeMoreActions = (
    <section>
      <span
        onClick={(e) => {
          setActiveKey(activeKey === DEFAULT_ACTIVE_KEY ? DEFAULT_DISABLED_KEY : DEFAULT_ACTIVE_KEY)
          setViewMoreDetails(true)
          e.stopPropagation()
        }}
        className="link"
      >
        {seeMoreTitle ? seeMoreTitle : translate('general.see-more')}
      </span>
    </section>
  )

  const footerActions = viewMoreDetails ? seeLessActions : seeMoreActions

  const handleCollapseChange = () => {
    setActiveKey(activeKey === DEFAULT_ACTIVE_KEY ? DEFAULT_DISABLED_KEY : DEFAULT_ACTIVE_KEY)
    setViewMoreDetails(!viewMoreDetails)
  }

  const collapseTitle = (): ReactNode => (
    <div className="custom_collapse__no_space">
      <p className={titleClassName}>{title}</p>
      {items.length > itemsToShow ? titleItems() : null}
    </div>
  )

  const titleItems = () => {
    let titleItems = []
    for (let i = 0; i < itemsToShow; i++) {
      titleItems.push(<p>{items[i]}</p>)
    }
    return <div>{titleItems}</div>
  }

  const collapseBody = (): ReactNode => {
    let content = []
    for (let i = itemsToShow; i < items.length; i++) {
      content.push(<p>{items[i]}</p>)
    }
    return <div className="custom_collapse__no_space">{content}</div>
  }

  return (
    <div>
      <Collapse activeKey={activeKey} onChange={handleCollapseChange} className="custom_collapse">
        <Panel showArrow={false} header={collapseTitle()} key={DEFAULT_ACTIVE_KEY}>
          {collapseBody()}
          {contentOnly && content}
        </Panel>
      </Collapse>
      {(items.length > itemsToShow || contentOnly) && (
        <section className="custom_collapse__action">{footerActions}</section>
      )}
    </div>
  )
}

export default CustomCollapse
